// extracted by mini-css-extract-plugin
export var attachment = "_no-a";
export var emailContainer = "_no-4";
export var emailContentPaddedContainer = "_no-b";
export var emailHeader = "_no-6";
export var emailIframe = "_no-3";
export var emailInfoIcon = "_no-9";
export var emailShortenedSummary = "_no-e";
export var infoDropdown = "_no-0";
export var infoRowBoundedContent = "_no-d";
export var internal = "_no-5";
export var merchant = "_no-8";
export var messageInputContainer = "_no-h";
export var normal = "_no-7";
export var replyCard = "_no-f";
export var subtleButton = "_no-1";
export var subtleButtonIconContainer = "_no-2";
export var toggleViewRepliesButton = "_no-c";
export var wrappingText = "_no-g";